import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.object.keys";
import _defineProperty from "D:/zlwl/portal/node_modules/@babel/runtime/helpers/esm/defineProperty";
import "core-js/modules/web.dom.iterable";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/zlwl/portal/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.array.find";
import "core-js/modules/es6.regexp.split";
import "core-js/modules/es6.number.constructor";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//中继器
import { listConfig, getLog, updateConfig } from "@/api/configurationlist";
import { progressControl } from "@/api/particulars";
import Edit from "./components/edit.vue";
export default {
  name: "repeater",
  props: ["deviceSn", "deviceDid"],
  data: function data() {
    var _this = this;

    var checkNumber = function checkNumber(rule, value, callback) {
      if (!isNaN(Number(value))) {
        callback();
      } else {
        callback(new Error(_this.$t("lang.repeater.numberRuleErr")));
      }
    };

    var checkServer = function checkServer(rule, value, callback) {
      var test = /(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5]):([0-9]|[1-9]\d|[1-9]\d{2}|[1-9]\d{3}|[1-5]\d{4}|6[0-4]\d{3}|65[0-4]\d{2}|655[0-2]\d|6553[0-5])$/;

      for (var i = 0; i < value.length; i++) {
        if (!test.test(value[i])) {
          callback(new Error(_this.$t("lang.repeater.ipRuleErr")));
        }
      }

      callback(); // if (test.test(value)) {
      //   callback();
      // } else {
      //   callback(new Error("格式不正确"));
      // }
    };

    var checkIp = function checkIp(rule, value, callback) {
      var test = /(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5]):([0-9]|[1-9]\d|[1-9]\d{2}|[1-9]\d{3}|[1-5]\d{4}|6[0-4]\d{3}|65[0-4]\d{2}|655[0-2]\d|6553[0-5])$/;
      var data = value.split(" ").filter(function (v) {
        return v;
      });
      console.log(data);

      for (var i = 0; i < data.length; i++) {
        if (test.test(data[i])) {} else {
          callback(new Error(_this.$t("lang.repeater.ipRuleErr")));
        }
      }

      callback();
    };

    var checkPort = function checkPort(rule, value, callback) {
      var test = /^([0-9]{1,4}|[1-5][0-9]{4}|6[0-4][0-9]{3}|65[0-4][0-9]{2}|655[0-2][0-9]|6553[0-5])$/;

      if (test.test(value)) {
        callback();
      } else {
        callback(new Error(_this.$t("lang.repeater.portRuleErr")));
      }
    };

    var checkName = function checkName(rule, value, callback) {
      if (value >= 0 && value <= 31) {
        if (_this.dataOption.find(function (item) {
          return item.name == value;
        })) {
          callback(new Error(_this.$t("lang.repeater.nameRuleErr1")));
        } else {
          callback();
        }
      } else {
        callback(new Error(_this.$t("lang.repeater.nameRuleErr2")));
      }
    };

    return {
      activeName: "first",
      serverOption: {
        enabled: "",
        net_proto: "",
        proto: "",
        hbt_interval: "",
        server: [],
        status: "",
        conn_num: ""
      },
      dataOption: [],
      serialData: [],
      seniorData: {},
      commData: {},
      deleteDataList: [],
      loading: false,
      // timer: null,
      rules: {
        hbt_interval: [{
          required: true,
          message: this.$t("lang.repeater.heartbeatRuleErr"),
          trigger: "blur"
        }, {
          validator: checkNumber,
          trigger: "blur"
        }],
        server: [{
          validator: checkServer,
          trigger: "change"
        }]
      },
      rules2: {
        sendto: [{
          validator: checkIp,
          trigger: "blur"
        }]
      },
      rules3: {
        port_recv: [{
          validator: checkPort,
          trigger: "blur"
        }]
      },
      rules4: {
        name: [{
          required: true,
          message: this.$t("lang.repeater.numberRuleErr2"),
          trigger: "blur"
        }, {
          validator: checkName,
          trigger: "blur"
        }]
      },
      rules5: {
        tcp_keepalive_time: [{
          required: true,
          message: this.$t("lang.repeater.tcpRuleErr"),
          trigger: "blur"
        }, {
          validator: checkNumber,
          trigger: "blur"
        }],
        tcp_keepalive_interval: [{
          required: true,
          message: this.$t("lang.repeater.tcpRuleErr2"),
          trigger: "blur"
        }, {
          validator: checkNumber,
          trigger: "blur"
        }],
        tcp_keepalive_probes: [{
          required: true,
          message: this.$t("lang.repeater.tcpRuleErr3"),
          trigger: "blur"
        }, {
          validator: checkNumber,
          trigger: "blur"
        }],
        log_file_num: [{
          required: true,
          message: this.$t("lang.repeater.logRuleErr"),
          trigger: "blur"
        }, {
          validator: checkNumber,
          trigger: "blur"
        }],
        log_file_size: [{
          required: true,
          message: this.$t("lang.repeater.logRuleErr2"),
          trigger: "blur"
        }, {
          validator: checkNumber,
          trigger: "blur"
        }]
      },
      master: false,
      serial: false
    };
  },
  mounted: function () {
    var _mounted = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              this.loading = true;
              _context.next = 3;
              return this.getData();

            case 3:
              // if (!this.timer) {
              //   this.timer = setInterval(() => {
              //     this.getData();
              //   }, 10000);
              // }
              this.loading = false;

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function mounted() {
      return _mounted.apply(this, arguments);
    }

    return mounted;
  }(),
  // beforeDestroy() {
  //   if (this.timer) {
  //     clearInterval(this.timer);
  //   }
  // },
  methods: {
    handleClick: function handleClick() {},
    addServer: function addServer() {
      this.serverOption.server.push("");
    },
    removeClick: function removeClick(e) {
      this.serverOption.server = this.serverOption.server.filter(function (v, index) {
        return index != e - 1;
      });
    },
    downClick: function downClick() {
      var _this2 = this;

      getLog({
        did: this.deviceDid,
        sn: this.deviceSn,
        mess: "smartcat"
      }).then(function (res) {
        var data = res.data; // 创建Blob对象（类文件对象）

        var blob = new Blob([data]); // let disposition = decodeURI(res.headers['content-disposition'])
        // 从响应头中获取文件名
        // let filename = disposition.substring(disposition.indexOf('fileName=') + 9, disposition.length)

        if ("download" in document.createElement("a")) {
          // 非IE下载
          // 创建隐藏下载超链接
          var elink = document.createElement("a"); // 使用超链接的download属性下载文件

          elink.download = _this2.$t("lang.repeater.logFile");
          elink.style.display = "none"; // 使用Blob创建一个指向类型化数组的URL

          elink.href = URL.createObjectURL(blob);
          document.body.appendChild(elink); // 自定点击超链接

          elink.click(); // 释放URL对象

          URL.revokeObjectURL(elink.href);
          document.body.removeChild(elink);
        } else {
          //IE10+下载
          navigator.msSaveBlob(blob, filename);
        }
      });
    },
    editComClick: function editComClick(e) {
      this.commData = e;
      this.$refs["comm"].editShow = true;
    },
    addData: function addData() {
      this.dataOption.push({
        enabled: "",
        name: "",
        net_proto: "TCP",
        port_recv: "",
        port_send: "",
        proto: "Pass-Through",
        sendto: "",
        index: this.dataOption.length + 1,
        isAdd: true
      });
    },
    removeData: function removeData(e) {
      var _this3 = this;

      this.dataOption = this.dataOption.filter(function (v, index) {
        if (index != e) {
          return v;
        } else {
          _this3.deleteDataList.push(v);

          return;
        }
      });
    },
    updateData: function () {
      var _updateData = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var _this4 = this;

        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                _context4.next = 3;
                return this.$refs["port"].validate();

              case 3:
                _context4.next = 5;
                return this.$refs["zh_name"].validate();

              case 5:
                _context4.next = 7;
                return this.$refs["sendto"].validate();

              case 7:
                if (this.master) {
                  this.$refs["server"].validate(function (v) {
                    if (v) {
                      _this4.$refs["currency"].validate(function (v4) {
                        if (v4) {
                          _this4.loading = true;
                          var serial = [];
                          var service = {};
                          var data = [];

                          _this4.serialData.forEach(function (item, index) {
                            serial.push({
                              section: item.comm,
                              options: {
                                baudrate: item.baudrate,
                                data_bits: item.data_bits,
                                stop_bits: item.stop_bits,
                                flow_ctrl: item.flow_ctrl,
                                enable_frame: item.enable_frame,
                                parity: item.parity,
                                frame_len: item.frame_len
                              },
                              config: "smartcat",
                              action: 0,
                              index: [index]
                            });
                          });

                          service = {
                            section: "service",
                            config: "smartcat",
                            action: 0,
                            index: [0],
                            options: {
                              enabled: _this4.seniorData.enabled ? 1 : 0,
                              enable_debug: _this4.seniorData.enable_debug ? 1 : 0,
                              log_file_num: _this4.seniorData.log_file_num,
                              log_file_size: _this4.seniorData.log_file_size,
                              log_priority: _this4.seniorData.log_priority,
                              tcp_keepalive_time: _this4.seniorData.tcp_keepalive_time,
                              tcp_keepalive_interval: _this4.seniorData.tcp_keepalive_interval,
                              tcp_keepalive_probes: _this4.seniorData.tcp_keepalive_probes
                            }
                          };

                          _this4.dataOption.forEach(function (item) {
                            if (item.isAdd) {
                              data.push({
                                section: "mode",
                                config: "smartcat",
                                action: 1,
                                index: [item.index],
                                options: {
                                  enabled: item.enabled ? "1" : "0",
                                  upload_term: item.upload_term ? "1" : "0",
                                  name: item.name,
                                  net_proto: item.net_proto,
                                  port_recv: item.port_recv,
                                  port_send: item.port_recv,
                                  sendto: item.sendto.split(" ").filter(function (v) {
                                    return v;
                                  }).join(" "),
                                  proto: item.proto
                                }
                              });
                            } else {
                              data.push({
                                section: "mode",
                                config: "smartcat",
                                action: 0,
                                index: [item.index],
                                options: {
                                  enabled: item.enabled ? "1" : "0",
                                  upload_term: item.upload_term ? "1" : "0",
                                  name: item.name,
                                  net_proto: item.net_proto,
                                  port_recv: item.port_recv,
                                  port_send: item.port_recv,
                                  sendto: item.sendto.split(" ").filter(function (v) {
                                    return v;
                                  }).join(" "),
                                  proto: item.proto
                                }
                              });
                            }
                          });

                          _this4.deleteDataList.forEach(function (item) {
                            data.push({
                              section: "mode",
                              config: "smartcat",
                              action: 2,
                              index: [item.index],
                              options: {
                                enabled: item.enabled ? "1" : "0",
                                name: item.name,
                                net_proto: item.net_proto,
                                port_recv: item.port_recv,
                                port_send: item.port_recv,
                                sendto: item.sendto,
                                proto: item.proto
                              }
                            });
                          });

                          updateConfig(_this4.deviceSn, _this4.deviceDid, [{
                            section: "master",
                            config: "smartcat",
                            action: 0,
                            index: [0],
                            options: {
                              enabled: _this4.serverOption.enabled ? "1" : "0",
                              net_proto: _this4.serverOption.net_proto,
                              proto: _this4.serverOption.proto,
                              hbt_interval: _this4.serverOption.hbt_interval
                            },
                            lists: {
                              server: _this4.serverOption.server
                            }
                          }].concat(serial, [service], data)).then( /*#__PURE__*/function () {
                            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(res) {
                              return regeneratorRuntime.wrap(function _callee2$(_context2) {
                                while (1) {
                                  switch (_context2.prev = _context2.next) {
                                    case 0:
                                      _context2.next = 2;
                                      return _this4.getData();

                                    case 2:
                                      _context2.next = 4;
                                      return _this4.restart();

                                    case 4:
                                      _this4.$message({
                                        message: _this4.$t("lang.repeater.saveSuccess"),
                                        type: "success"
                                      });

                                      _this4.loading = false;

                                    case 6:
                                    case "end":
                                      return _context2.stop();
                                  }
                                }
                              }, _callee2);
                            }));

                            return function (_x) {
                              return _ref.apply(this, arguments);
                            };
                          }());
                        } else {
                          _this4.$message({
                            type: "warning",
                            message: _this4.$t("lang.repeater.seniorErr")
                          });
                        }
                      });
                    } else {
                      _this4.$message({
                        type: "warning",
                        message: _this4.$t("lang.repeater.serverErr")
                      });

                      return;
                    }
                  });
                } else {
                  this.$refs["currency"].validate(function (v4) {
                    if (v4) {
                      _this4.loading = true;
                      var service = {};
                      var data = [];
                      service = {
                        section: "service",
                        config: "smartcat",
                        action: 0,
                        index: [0],
                        options: {
                          enabled: _this4.seniorData.enabled ? 1 : 0,
                          enable_debug: _this4.seniorData.enable_debug ? 1 : 0,
                          log_file_num: _this4.seniorData.log_file_num,
                          log_file_size: _this4.seniorData.log_file_size,
                          log_priority: _this4.seniorData.log_priority,
                          tcp_keepalive_time: _this4.seniorData.tcp_keepalive_time,
                          tcp_keepalive_interval: _this4.seniorData.tcp_keepalive_interval,
                          tcp_keepalive_probes: _this4.seniorData.tcp_keepalive_probes
                        }
                      };

                      _this4.dataOption.forEach(function (item) {
                        if (item.isAdd) {
                          data.push({
                            section: "mode",
                            config: "smartcat",
                            action: 1,
                            index: [item.index],
                            options: {
                              enabled: item.enabled ? "1" : "0",
                              upload_term: item.upload_term ? "1" : "0",
                              name: item.name,
                              net_proto: item.net_proto,
                              port_recv: item.port_recv,
                              port_send: item.port_recv,
                              sendto: item.sendto.split(" ").filter(function (v) {
                                return v;
                              }).join(" "),
                              proto: item.proto
                            }
                          });
                        } else {
                          data.push({
                            section: "mode",
                            config: "smartcat",
                            action: 0,
                            index: [item.index],
                            options: {
                              enabled: item.enabled ? "1" : "0",
                              upload_term: item.upload_term ? "1" : "0",
                              name: item.name,
                              net_proto: item.net_proto,
                              port_recv: item.port_recv,
                              port_send: item.port_recv,
                              sendto: item.sendto.split(" ").filter(function (v) {
                                return v;
                              }).join(" "),
                              proto: item.proto
                            }
                          });
                        }
                      });

                      _this4.deleteDataList.forEach(function (item) {
                        data.push({
                          section: "mode",
                          config: "smartcat",
                          action: 2,
                          index: [item.index],
                          options: {
                            enabled: item.enabled ? "1" : "0",
                            name: item.name,
                            net_proto: item.net_proto,
                            port_recv: item.port_recv,
                            port_send: item.port_recv,
                            sendto: item.sendto,
                            proto: item.proto
                          }
                        });
                      });

                      updateConfig(_this4.deviceSn, _this4.deviceDid, [service].concat(data)).then( /*#__PURE__*/function () {
                        var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(res) {
                          return regeneratorRuntime.wrap(function _callee3$(_context3) {
                            while (1) {
                              switch (_context3.prev = _context3.next) {
                                case 0:
                                  _context3.next = 2;
                                  return _this4.getData();

                                case 2:
                                  _context3.next = 4;
                                  return _this4.restart();

                                case 4:
                                  _this4.$message({
                                    message: _this4.$t("lang.repeater.saveSuccess"),
                                    type: "success"
                                  });

                                  _this4.loading = false;

                                case 6:
                                case "end":
                                  return _context3.stop();
                              }
                            }
                          }, _callee3);
                        }));

                        return function (_x2) {
                          return _ref2.apply(this, arguments);
                        };
                      }());
                    } else {
                      _this4.$message({
                        type: "warning",
                        message: _this4.$t("lang.repeater.seniorErr")
                      });
                    }
                  });
                }

                _context4.next = 13;
                break;

              case 10:
                _context4.prev = 10;
                _context4.t0 = _context4["catch"](0);
                this.$message({
                  type: "warning",
                  message: this.$t("lang.repeater.repeaterErr")
                });

              case 13:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[0, 10]]);
      }));

      function updateData() {
        return _updateData.apply(this, arguments);
      }

      return updateData;
    }(),
    getData: function getData() {
      var _this5 = this;

      return new Promise(function (reslove, reject) {
        listConfig(_this5.deviceSn, _this5.deviceDid, [{
          section: "master",
          config: "smartcat",
          options: [{
            option: "enabled"
          }, {
            option: "net_proto"
          }, {
            option: "proto"
          }, {
            option: "hbt_interval"
          }, {
            option: "status"
          }, {
            option: "conn_num"
          }],
          lists: [{
            list: "server"
          }, {
            list: "serial"
          }]
        }, {
          section: "mode",
          config: "smartcat",
          options: [{
            option: "enabled"
          }, {
            option: "upload_term"
          }, {
            option: "net_proto"
          }, {
            option: "port_recv"
          }, {
            option: "proto"
          }, {
            option: "sendto"
          }, {
            option: "port_send"
          }, {
            option: "name"
          }]
        }, {
          section: "initconfig",
          config: "system",
          options: [{
            option: "product_model"
          }, {
            option: "vendor_name"
          }]
        }, {
          section: "service",
          config: "smartcat",
          options: [{
            option: "enabled"
          }, {
            option: "enable_debug"
          }, {
            option: "log_file_num"
          }, {
            option: "log_file_size"
          }, {
            option: "log_priority"
          }, {
            option: "tcp_keepalive_time"
          }, {
            option: "tcp_keepalive_interval"
          }, {
            option: "tcp_keepalive_probes"
          }, {
            option: "enable_master"
          }, {
            option: "enable_serial"
          }]
        }]).then(function (res) {
          if (!res.data.data.mess) {
            _this5.loading = false;
            return _this5.$message({
              type: "warning",
              message: _this5.$t("lang.repeater.repeaterErr2")
            });
          }

          var server = res.data.data.mess[0].s_objects[0];
          var optionData = res.data.data.mess;
          var comm = optionData[0].s_objects[0].lists.serial;
          var commData = [];
          var senior = res.data.data.mess[3].s_objects[0].options;
          _this5.dataOption = [];
          res.data.data.mess[1].s_objects.forEach(function (item) {
            if (item.sname != "master") {
              item.options.enabled == 0 ? item.options.enabled = false : item.options.enabled = true;
              item.options.upload_term == 0 ? item.options.upload_term = false : item.options.upload_term = true;
              item.options.index = item.index;

              _this5.dataOption.push(item.options);
            }
          });
          _this5.serverOption = {
            enabled: server.options.enabled == 0 ? false : true,
            net_proto: server.options.net_proto,
            proto: server.options.proto,
            hbt_interval: server.options.hbt_interval,
            server: server.lists.server,
            status: server.options.status,
            conn_num: server.options.conn_num
          };
          senior.enabled == 0 ? senior.enabled = false : senior.enabled = true;
          senior.enable_debug == 0 ? senior.enable_debug = false : senior.enable_debug = true;
          senior.enable_master == 1 ? _this5.master = true : _this5.master = false;
          senior.enable_serial == 1 ? _this5.serial = true : _this5.serial = false;
          _this5.seniorData = senior;
          comm.forEach(function (v) {
            commData.push({
              section: v,
              config: "smartcat",
              options: [{
                option: "name"
              }, {
                option: "baudrate"
              }, {
                option: "parity"
              }, {
                option: "data_bits"
              }, {
                option: "stop_bits"
              }, {
                option: "flow_ctrl"
              }, {
                option: "enable_frame"
              }, {
                option: "timeout"
              }, {
                option: "frame_len"
              }]
            });
          });
          listConfig(_this5.deviceSn, _this5.deviceDid, [].concat(commData)).then(function (res2) {
            _this5.serialData = [];
            res2.data.data.mess.forEach(function (v) {
              _this5.serialData.push(_objectSpread(_objectSpread({}, v.s_objects[0].options), {}, {
                comm: v.s_objects[0].sname
              }));
            });
            reslove();
          });
        });
      });
    },
    restart: function restart() {
      var _this6 = this;

      return new Promise(function (reslove, reject) {
        progressControl([{
          process: "smartcat",
          action: "restart",
          type: 0
        }], String(_this6.deviceDid), _this6.deviceSn).then(function (res) {
          reslove();
        });
      });
    },
    refsh: function () {
      var _refsh = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                this.loading = true;
                _context5.next = 3;
                return this.getData();

              case 3:
                this.loading = false;

              case 4:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function refsh() {
        return _refsh.apply(this, arguments);
      }

      return refsh;
    }()
  },
  components: {
    Edit: Edit
  },
  filters: {
    customFilter: function customFilter(e) {
      var data;

      switch (e) {
        case "N":
          data = "None";
          break;

        case "E":
          data = "Even";
          break;

        case "M":
          data = "Mask";
          break;

        case "O":
          data = "Odd";
          break;

        case "S":
          data = "Space";
          break;

        case "R":
          data = "RTS/CTS";
          break;

        case "X":
          data = "XON/XOFF";
          break;

        case "D":
          data = "DTR/DSR";
          break;

        default:
          data = e;
          break;
      }

      return data;
    }
  }
};